var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CheckboxList"},_vm._l((_vm.options),function(option){return _c('ja-checkbox',_vm._b({key:option.name,staticClass:"CheckboxList-Item",attrs:{"on-change":_vm.handleChange}},'ja-checkbox',option,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }